import * as React from 'react';
import { OutlinedInput, InputAdornment, styled } from '@mui/material';
import { MaterialUiFieldProps } from '../../core/form';
import { borderLightGrey, labelGreyColour, whiteBackground } from '../../appComponents/cssConstants';
import SearchSvg from '../../images/search.svg';

const SearchInput: React.FC<MaterialUiFieldProps & { className?: string }> = ({
	value,
	onChange,
	placeholder,
	className
}) => {
	return (
		<StyledOutlinedInput
			className={className}
			value={value}
			onChange={onChange}
			id="outlined-adornment-search"
			startAdornment={
				<InputAdornment position="start">
					<img src={SearchSvg} alt="Search icon" style={{ width: 16, height: 16, marginRight: 12 }} />
				</InputAdornment>
			}
			placeholder={placeholder}
		/>
	);
};

export default SearchInput;

export const StyledOutlinedInput = styled(OutlinedInput)`
	border-radius: 12px;
	background-color: ${whiteBackground};
	width: -webkit-fill-available;
	height: 48px;
	margin: 25px 0 10px 0; // header is 95, padding-top is 110px, so margin-top for search bar is 15px
	padding-left: 20px;
	border: 1px solid ${borderLightGrey};

	& .MuiInputBase-input {
		padding-top: 16px !important;
	}

	& .MuiInputBase-input::placeholder {
		opacity: 1;
		color: ${labelGreyColour};
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;
		letter-spacing: 0.1px;
	}

	& .MuiInputAdornment-positionStart {
		margin-right: 0;
	}

	.MuiOutlinedInput-notchedOutline,
	&.Mui-focused .MuiOutlinedInput-notchedOutline,
	&:hover .MuiOutlinedInput-notchedOutline {
		border: none;
	}
`;
